import React from 'react'
import { DimensionValue, Platform } from 'react-native'
import Skeleton from 'react-native-reanimated-skeleton'

import { DS } from '../../design-system'
import { getDSColorWithOpacity } from '../../design-system/Palette'

export const SkeletonLoader = ({
  height,
  width = 292,
  flexGrow = 0
}: { height: number; width?: DimensionValue; flexGrow?: number }) => {
  return (
    <Skeleton
      isLoading={true}
      layout={[
        {
          height: '100%',
          width: '100%',
          borderRadius: DS.spacing[16],
          borderColor: DS.palette['Global/White'],
          borderWidth: 2
        }
      ]}
      highlightColor={getDSColorWithOpacity('Global/White', 0.5)}
      containerStyle={{
        minWidth: width,
        height: height,
        flexGrow,
        ...Platform.select({
          ios: {
            shadowColor: '#000000',
            shadowRadius: 2,
            shadowOffset: { height: 0, width: 2 },
            shadowOpacity: 0.05
          },
          android: {
            elevation: 2
          }
        })
      }}
      boneColor={DS.palette['Brand/Light Grey']}
    />
  )
}
